import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AuthShell, AuthField, AuthError } from "../components/AuthShell";
import { authForgotPassword, formatApiErrorDetail } from "../lib/api";
import { Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await authForgotPassword(email.trim());
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Reset your password" subtitle="We'll send a reset link if an account exists.">
      {done ? (
        <div className="space-y-4">
          <div className="rounded-lg border border-emerald-900/50 bg-emerald-950/40 px-3.5 py-3 text-sm text-emerald-300" data-testid="forgot-success">
            If an account exists for {email}, a reset link has been generated. Check your inbox (dev: see server logs).
          </div>
          <Link to="/login" className="text-sm text-blue-400 hover:text-blue-300">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <AuthError message={error} />
          <AuthField label="Work email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" data-testid="forgot-email" />
          <button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full h-11 rounded-lg bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-sm font-semibold text-white flex items-center justify-center gap-2 transition-colors">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Send reset link
          </button>
          <p className="text-sm text-zinc-400 text-center"><Link to="/login" className="text-blue-400 hover:text-blue-300">Back to sign in</Link></p>
        </form>
      )}
    </AuthShell>
  );
}
